import React, { useState } from 'react';

import { 
  Campaign, 
} from "@dndModels";

import SendToCharacters from '@dndComponents/campaign/SendToCharacters';
import MailButton from '@components/input/buttons/MailButton';

interface Props {
  campaign: Campaign;
}

export default function CampaignMailButton({
  campaign,
}: Props) {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <SendToCharacters
        campaign={campaign}
        open={open}
        onClose={() => { setOpen(false); }}
      />
    );
  }

  return (
    <>
      <MailButton
        onClick={() => { setOpen(true); }}
      />
      { renderExtras() }
    </>
  ); 
}

